import { render, staticRenderFns } from "./reports-overview-pie-graph.vue?vue&type=template&id=f2baeafe"
import script from "./reports-overview-pie-graph.vue?vue&type=script&lang=js"
export * from "./reports-overview-pie-graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports